import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { LinkComponent } from "../../core/et3-table/UserCustomHelpers";

export const ACCOUNTS_DELETION_HEADERS: GridColDef[] = [
  {
    headerName: "User ID",
    field: "userId",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <LinkComponent
          href={`/users/advanced?id=${params.row.userId}`}
          text={`${params.row.userId}`}
          style={{}}
        />
      );
    }
  },
  {
    headerName: "Rating Emojis",
    field: "ratingEmojis"
  },
  {
    headerName: "Reasons",
    field: "reasons"
  },
  {
    headerName: "Comment",
    field: "comment"
  },
  {
    headerName: "Date",
    field: "date"
  }
];
